<template>
  <v-container fluid class="fill-height pa-0 fondoBg">
    <v-row no-gutters class="h-100">
      <!-- Bloque izquierdo solo visible en mayor que md, col 7 en version pc y col 12 en versión < md-->
      <v-col class="d-none d-md-flex" cols="12" md="5">
        <v-container fluid class="fill-height pa-0 white">
          <v-row no-gutters class>
            <v-col class="px-4 px-md-8 ml-auto" cols="12" xl="6" lg="8">
              <p class="headline text-center font-weight-bold mt-5">Tu pedido</p>
              <pedirCarritoContenido
                v-bind:opciones="{
						      select: false,
						      isResumen: false,
						      totales: true
						    }"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-col>

      <!-- Bloque derecho visible siempre, col 7 en version pc y col 12 en versión < md-->
      <v-col class="borderLeft" cols="12" md="7">
        <v-container fluid class="fill-height pa-0">
          <v-row no-gutters class>
            <v-col class="pa-0" cols="12" xl="7" lg="9">
              <v-card class="pa-0 transparent" outlined tile>
                <div class="d-flex justify-center my-5">
                  <v-img
                    class
                    src="../../assets/img/logoFunEatsNegro.png"
                    lazy-src="../../assets/img/logoFunEatsNegro.png"
                    contain
                    max-width="200"
                  ></v-img>
                </div>
                <v-expansion-panels tile flat class="borderTopBottom d-md-none">
                  <v-expansion-panel class="white py-2">
                    <v-expansion-panel-header class>
                      Ver artículos
                      <v-spacer></v-spacer>
                      <span class="text-right pr-4 font-weight-bold">{{ carrito.precio_total }} €</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <pedirCarritoContenido
                        v-bind:opciones="{
						              select: false,
						              isResumen: false,
						              totales: true
						            }"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <!-- Bloque de pagos varios-->
                <v-col cols="12" sm="10" offset-sm="1" offset-md="0" md="12" class="pa-0">
                  <p class="headline text-center font-weight-bold mt-5">Formas de pago</p>
                  <v-card :elevation="0" class="transparent px-4 px-md-8">
                    <v-card v-for :elevation="1" tile class="mx-auto my-4" outlined>
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title class="title mb-0">Tarjeta online</v-list-item-title>
                          <v-list-item-subtitle>Facil, rápido y cómodo</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-avatar tile size="80" color>
                          <v-img
                            class="elevation-0"
                            src="../../assets/img/pagoTarjetaOnline.png"
                            lazy-src="../../assets/img/pagoTarjetaOnline.png"
                            aspect-ratio="1.7"
                            contain
                          ></v-img>
                        </v-list-item-avatar>
                      </v-list-item>
                    </v-card>

                    <v-card :elevation="1" tile class="mx-auto my-4" outlined>
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title class="title mb-0">Tarjeta online</v-list-item-title>
                          <v-list-item-subtitle>Facil, rápido y cómodo</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-avatar tile size="80" color>
                          <v-img
                            class="elevation-0"
                            src="../../assets/img/pagoTarjetaOnline.png"
                            lazy-src="../../assets/img/pagoTarjetaOnline.png"
                            aspect-ratio="1.7"
                            contain
                          ></v-img>
                        </v-list-item-avatar>
                      </v-list-item>
                    </v-card>
                    <v-card :elevation="1" tile class="mx-auto my-4" outlined>
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title class="title mb-0">Tarjeta a la entrega</v-list-item-title>
                          <v-list-item-subtitle>El repartidor te cobra al entregar el pedido</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-avatar tile size="80" color>
                          <v-img
                            class="elevation-0"
                            src="../../assets/img/pagoTarjetaEntrega.png"
                            lazy-src="../../assets/img/pagoTarjetaEntrega.png"
                            aspect-ratio="1.7"
                            contain
                          ></v-img>
                        </v-list-item-avatar>
                      </v-list-item>
                    </v-card>
                    <v-card :elevation="1" tile class="mx-auto my-4" outlined>
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title class="title mb-0">Pago en efectivo</v-list-item-title>
                          <v-list-item-subtitle>Selecciona esta opción para pagar con dinero.</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-avatar tile size="80" color>
                          <v-img
                            class="elevation-0"
                            src="../../assets/img/pagoMetalico.png"
                            lazy-src="../../assets/img/pagoMetalico.png"
                            aspect-ratio="1.7"
                            contain
                          ></v-img>
                        </v-list-item-avatar>
                      </v-list-item>
                    </v-card>
                    <div class="d-flex justify-center mb-4">
                      <v-img
                        class="white--text align-end"
                        src="../../assets/img/logoPago.png"
                        lazy-src="../../assets/img/logoPago.png"
                        height="50"
                        aspect-ratio="1.7"
                        contain
                      ></v-img>
                    </div>
                    <v-divider></v-divider>
                    <v-card-actions class="px-0">
                      <v-btn class small text style="text-transform:none;">Términos y condiciones</v-btn>
                      <v-btn class small text style="text-transform:none;">Devoluciones</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import pedirCarritoContenido from "@/components/Pedidos/pedir_carrito_contenido.vue";
import loginDialog from "@/components/LoginDialog.vue";
import finalizarStripe from "@/components/Finalizar/FinalizarStripe.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import { configJson } from "@/utils/config";

export default {
  components: {
    loginDialog,
    pedirCarritoContenido,
    finalizarStripe
  },
  data() {
    return {
      panelCarrito: 1,
      stripe: null,
      stripe_key: configJson.stripe.api_key,
      complete: false,
      loading: false,
      stripeOptions: {
        // see https://stripe.com/docs/stripe.js#element-options for details
      }
    };
  },
  computed: {
    ...mapState({
      isLogged: state => state.auth.isLogged,
      carrito: state => state.pedido.carrito,
      forma_envio: state => state.pedido.activePedido.forma_envio,
      formaPago: state => state.config.formaPago,
      isMobile: state => state.app.isMobile
    }),
    ...mapGetters({
      calculoImpuestosCarrito: "pedido/calculoImpuestosCarrito"
    }),
    dialogLogin: {
      get() {
        return this.$store.state.app.dialogLogin;
      },
      set(value) {
        this.$store.commit("app/setDialogLogin", value);
      }
    },
    eleccion: {
      get: function() {
        return this.$store.state.pedido.activePedido.forma_pago != undefined
          ? this.$store.state.pedido.activePedido.forma_pago
          : "";
      },
      set: function(value) {
        this.$store.commit("pedido/setFormaPago", value);
        value == "efectivo" && this.forma_envio != "recoger"
          ? (this.dialogCambio = true)
          : null;
      }
    },
    isStripe: {
      get: function() {
        if (this.eleccion == "tarjeta_online") {
          //this.comprobarFormasPago();
          return true;
        }
      },
      set: function(value) {
        this.eleccion = null;
      }
    }
  },
  methods: {
    ...mapActions({
      navegarPagePedido: "pedido/navegarPagePedido"
    }),
    finalizarPedido() {
      let _vm = this;
      let precioNoCero = this.carrito.precio_total > 0;
      let noVacio = this.carrito.numero_producto > 0;

      if (noVacio && precioNoCero) {
        _vm.loading = true;
        this.$store
          .dispatch("pedido/finalizarPedido")
          .then(r => {})
          .catch(e => {
            console.log(e);
          })
          .finally(() => {
            _vm.loading = false;
          });
      }
    },
    comprobarFormasPago() {
      this.$store.dispatch("auth/getFormasPago");
    }
  },
  mounted() {
    if (!this.isLogged) this.dialogLogin = true;
    this.stripe = Stripe(configJson.stripe.api_key);
    this.comprobarFormasPago();
  },
  watch: {}
};
</script>

<style scoped>
.borderTopBottom {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.border {
  border: 1px solid #000;
}
.h-100 {
  height: 100%;
}
.fondoBg {
  background: rgb(244, 244, 244);
  background: linear-gradient(
    rgba(255, 255, 255) 0%,
    rgb(66, 245, 218, 0.2) 100%
  );
}
.borderLeft {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
}
</style>